/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
//import * as Styles from "../../../../../SharedModules/GridTable/StyleConstant";
import * as Styles from '../../../../../SharedModules/GridTable/StyleConstant';

function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);

  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }

  return date1Number - date2Number;
}

function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}

function batchNumberComparator(valueA, valueB) {
  return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
}

export const labelerTableHead = [
  {
    headerName: 'Batch Number',
    field: 'batchNum',
    comparator: batchNumberComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 2,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_210,
    cellStyle: {
      borderRightColor: Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Batch Date',
    field: 'batchDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_120,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Check Payee',
    field: 'checkPayeeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'CheckPayeeCell',
    cellClass: 'frr-ellipsis-text',
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_160,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total No of Checks',
    field: 'totCheckCnt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_195,
    isTextColorRed: true,
    excelAlignment: 'right',
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      textAlign: 'right',
    },

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Amount of Checks',
    field: 'totCheckAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_230,
    maxLength: Styles.Length_30,
    filter: 'agTextColumnFilter',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    cellRenderer: 'TextFieldCell',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Complete',
    field: 'cfFrozen',
    cellRenderer: 'CheckboxCell',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    minWidth: Styles.Width_100,
    showCheckboxIcon: true,
    cellClass: 'ag-cell-checkbox',
    cellStyle: {
      borderRightColor: Styles.BorderColor,
    },
  },
];
